import api from './api';

// Global search (FECOA-2184). One request returns a few matches of each kind of
// record the signed-in user can open. The pop-up builds the links from the ids.

export const SEARCH_MIN_LENGTH = 2;

const CACHE_LIMIT = 50;
const CACHE_TTL_MS = 60 * 1000;
const cache = new Map();

export const normalizeQuery = (query = '') => query.trim().replace(/\s+/g, ' ');

// Results depend on who is signed in and which sponsor is selected.
const scopeKey = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}') || {};
    const sponsor = JSON.parse(localStorage.getItem('selectedSponsor') || '{}') || {};
    return `${user.id ?? user.email ?? ''}|${sponsor.id ?? ''}`;
  } catch {
    return '';
  }
};

const cacheKey = (query) => `${scopeKey()}|${normalizeQuery(query).toLowerCase()}`;

const readCache = (key) => {
  const hit = cache.get(key);
  if (!hit) return null;
  if (Date.now() - hit.at > CACHE_TTL_MS) {
    cache.delete(key);
    return null;
  }
  // Move to the end so the least recently used entry is dropped first.
  cache.delete(key);
  cache.set(key, hit);
  return hit.data;
};

// Instant answer for a query that was searched in the last minute.
export const getCachedSearch = (query) => readCache(cacheKey(query));

export const clearSearchCache = () => cache.clear();

export async function globalSearch(query, { signal } = {}) {
  const q = normalizeQuery(query);
  const key = cacheKey(q);
  const cached = readCache(key);
  if (cached) return cached;

  const response = await api.get('/api/search/', { params: { q }, signal });
  const data = response.data;
  cache.set(key, { data, at: Date.now() });
  if (cache.size > CACHE_LIMIT) cache.delete(cache.keys().next().value);
  return data;
}
